
export function cmp_str(s1, s2) {
  return s1.localeCompare(s2, undefined, { sensitivity: 'base' })
}

export function cmp_units(u1, u2) {
  let rv
  if (u1.online && !u2.online) return -1  // Sort by online status.
  if (u2.online && !u1.online) return 1
  rv = cmp_str(u1.name, u2.name)          // Then sort by name.
  if (rv) return rv
  if (u1.uid < u2.uid) return -1          // Then sort by numeric uid.
  if (u2.uid < u1.uid) return 1
  return 0
}

export function cmp_uids(s, uid1, uid2) {
  let u1 = s.units[uid1], u2 = s.units[uid2]
  return cmp_units(u1, u2)
}

const ONE_KB = 1<<10,
  ONE_MB = 1<<20,
  ONE_GB = 1<<30,
  ONE_TB = 1<<40,
  ONE_PB = 1<<50,
  ZERO = '0'.charCodeAt(0)

export function fsize_display(bytes) {
  let sz, rm, sz_suffix
  if (bytes < ONE_KB) {
    sz = bytes
    rm = 0
    sz_suffix = 'B'
  } else if (bytes < ONE_MB) {
    sz = Math.floor(bytes/ONE_KB)
    rm = Math.floor((bytes%ONE_KB)*10/ONE_KB)
    sz_suffix = 'K'
  } else if (bytes < ONE_GB) {
    sz = Math.floor(bytes/ONE_MB)
    rm = Math.floor((bytes%ONE_MB)*10/ONE_MB)
    sz_suffix = 'M'
  } else if (bytes < ONE_TB) {
    sz = Math.floor(bytes/ONE_GB)
    rm = Math.floor((bytes%ONE_GB)*10/ONE_GB)
    sz_suffix = 'G'
  } else if (bytes < ONE_PB) {
    sz = Math.floor(bytes/ONE_TB)
    rm = Math.floor((bytes%ONE_TB)*10/ONE_TB)
    sz_suffix = 'T'
  } else {
    return '>999T'
  }
  if (sz >= 10 || !rm)
    return `${sz}${sz_suffix}`
  return `${String.fromCharCode(ZERO+sz)}.${String.fromCharCode(ZERO+rm)}${sz_suffix}`
}

